var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jd-navigator"},[_c('el-image',{staticClass:"ask-icon",staticStyle:{"width":"1000px"},attrs:{"src":_vm.imgUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }